import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import AlarmNotificationProfileList from './containers/AlarmNotificationProfileList';
import AlarmNotificationProfileCreate from './containers/AlarmNotificationProfileCreate';
import AlarmNotificationProfileEdit from './containers/AlarmNotificationProfileEdit';
import AlarmNotificationProfileView from './containers/AlarmNotificationProfileView';
import { SYSTEM_CONFIGURATION_ROUTE, ALARM_NOTIFICATION_PROFILE, SYSTEM } from '../../constants';

interface Props {
}

const AlarmNotificationProfile: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${ALARM_NOTIFICATION_PROFILE}`}>
        <AlarmNotificationProfileList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${ALARM_NOTIFICATION_PROFILE}/create`}>
        <AlarmNotificationProfileCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${ALARM_NOTIFICATION_PROFILE}/edit`}>
        <AlarmNotificationProfileEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${ALARM_NOTIFICATION_PROFILE}/view`}>
        <AlarmNotificationProfileView />
      </Route>
    </Fragment>
  );
};

export default AlarmNotificationProfile;
